import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import BookClub from './pages/BookClub';
import Events from './pages/Events';
import Blog from './pages/Blog';
import Registration from './pages/Registration';
import Login from './pages/Login';
import Admin from './pages/Admin';
import PendingApproval from './pages/PendingApproval';
import Header from './components/Header';

function App() {
  const [user, setUser] = useState(null);
  const [userStatus, setUserStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Get user data from Firestore
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUser(user);
          setUserStatus(userData);
        }
      } else {
        setUser(null);
        setUserStatus(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if user is approved
  const isApproved = userStatus?.status === 'approved';
  // Check if user is pending
  const isPending = userStatus?.status === 'pending';
  // Check if user is admin
  const isAdmin = userStatus?.role === 'admin';

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {user && isApproved && <Header isAdmin={isAdmin} />}
        <Routes>
          {/* Public routes */}
          <Route 
            path="/" 
            element={
              user ? (
                isApproved ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Navigate to="/pending-approval" />
                )
              ) : (
                <Home />
              )
            } 
          />
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/pending-approval" 
            element={
              user && isPending ? (
                <PendingApproval />
              ) : (
                <Navigate to="/" />
              )
            } 
          />

          {/* Protected routes - require approved status */}
          <Route
            path="/dashboard"
            element={
              user ? (
                isApproved ? (
                  <Dashboard />
                ) : (
                  <Navigate to="/pending-approval" />
                )
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/bookclub"
            element={
              user ? (
                isApproved ? (
                  <BookClub />
                ) : (
                  <Navigate to="/pending-approval" />
                )
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/events"
            element={
              user ? (
                isApproved ? (
                  <Events />
                ) : (
                  <Navigate to="/pending-approval" />
                )
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/blog"
            element={
              user ? (
                isApproved ? (
                  <Blog />
                ) : (
                  <Navigate to="/pending-approval" />
                )
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* Admin route */}
          <Route
            path="/admin"
            element={
              user ? (
                isAdmin ? (
                  <Admin />
                ) : (
                  <Navigate to="/dashboard" />
                )
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;